export default __webpack_public_path__ + "static/climate-change-e7db90699082caedc62cff6d0d7cdc87.png";